import { QuestionAnalysisList } from './QuestionAnalysisList';

export default {
    list: QuestionAnalysisList,
};
